import type { PrintZone } from "@/components/print/DocumentPreview";
import type { PrintLayoutFormValues } from "./printLayoutForm";

const ZONE_BY_FIELD: Record<keyof PrintLayoutFormValues, PrintZone> = {
  paper: "page",
  marginTopMm: "page",
  marginSideMm: "page",
  marginBottomMm: "page",
  backgroundImageUrl: "page",
  headerLayout: "header",
  headerImageUrl: "header",
  headerLogoHeightPx: "header",
  headerHtml: "header",
  footerText: "footer",
  footerImageUrl: "footer",
  footerAlign: "footer",
  fontId: "body",
  fontSizePt: "body",
  lineHeight: "body",
  textColor: "body",
  titleColor: "body",
  showIssuerBlock: "body",
  stampShowCrmv: "sign",
  stampShowMapa: "sign",
};

/** Panel (zone) owning the first field with an error, or null when there is none. */
export function zoneForFirstError(errors: Partial<Record<string, unknown>>): PrintZone | null {
  const field = Object.keys(errors).find((key) => key in ZONE_BY_FIELD);
  return field ? ZONE_BY_FIELD[field as keyof PrintLayoutFormValues] : null;
}
